import { useEffect, useState, useMemo, useRef } from 'react'
import {
  Form,
  Input,
  Select,
  Checkbox,
  Radio,
  Button,
  Tooltip,
  Typography,
  InputNumber,
  Space,
  DatePicker,
  Cascader,
  TimePicker,
  TreeSelect,
  Badge,
} from 'antd'
import { SvgIcon, BasSwitch } from '@/components'
import styled from 'styled-components'
import moment from 'moment'
import {
  useTaskGroup,
  useGetTargetList,
  useGetEmailList,
  useGetAgentList,
  useGetSecurityDevice,
  useGetEmailSendList,
} from './utils'
import { useGetTaskBaseInfo } from '../task-list/utils'
import { disabledDate, disabledDateTime } from '@/utils/appointment'
import type { DefaultOptionType } from 'antd/es/cascader'
import { useNavigate, useLocation } from 'react-router-dom'
import React from 'react'
import { t } from '@/i18n'

interface SecurityDevice {
  id: string
  status: string
  name: string
  ip: string
}

interface SecurityDeviceType {
  deviceType: string
  devices: SecurityDevice[]
}

interface EmailCreateConfigProps {
  submitForm: (values: any) => void
  createForm: any
  initialValues?: any
  areaData: any
  templateState?: {
    selectedTemplateIds: string[]
    selectedCaseIds: string[]
    executeTemplateLatestCase: boolean
    selectedTemplateId?: string
    templateSwitchStates: Record<string, boolean>
  }
  onTemplateStateChange?: (newState: {
    selectedTemplateIds?: string[]
    selectedCaseIds?: string[]
    executeTemplateLatestCase?: boolean
    selectedTemplateId?: string
    templateSwitchStates: Record<string, boolean>
  }) => void
}

export const EmailCreateConfig = ({
  submitForm,
  createForm,
  initialValues,
  areaData,
  templateState,
  onTemplateStateChange,
}: EmailCreateConfigProps) => {
  const navigate = useNavigate()
  const { state: stateParams } = useLocation() as { state: { id?: string } }
  const [taskGroup, getTaskGroup] = useTaskGroup()
  const [targetList, getTargetList] = useGetTargetList()
  const [getAgentList] = useGetAgentList()
  const [getTaskBaseInfo, taskBaseInfo] = useGetTaskBaseInfo()
  const [emailList] = useGetEmailList()
  const [emailSendList, getEmailSendList] = useGetEmailSendList()
  const [getSecurityDevice] = useGetSecurityDevice()
  const [securityDeviceData, setSecurityDeviceData] = useState<SecurityDeviceType[]>([])
  // 移除 selectedChainId，因为现在是两级结构
  const [agentList, setAgentList] = useState<{ label: string; value: string }[]>([])
  const [monthList, setMonthList] = useState<{ title: string; value: number }[]>([])
  const [apiCallCount, setApiCallCount] = useState(0) // 添加接口调用计数器
  console.log('initialValues1111111111111111', initialValues)

  // 合并状态管理
  const [formState, setFormState] = useState({
    verifyMode: initialValues?.verification_mode_id || [2],
    executeType: initialValues?.execute_type || 1,
    executeTimes: initialValues?.execute_times || 1,
    taskTime: initialValues?.task_time
      ? moment.isMoment(initialValues.task_time)
        ? initialValues.task_time
        : moment(initialValues.task_time, 'HH:mm:ss')
      : undefined,
    encode: initialValues?.encode || false,
    schedulerType: initialValues?.scheduler_type || 'scheduler_type_daily',
    executeTimesLimit: initialValues?.execution_times || 0,
    dayOfWeek: initialValues?.day_of_week || [],
    dayOfMonth: initialValues?.day_of_month || [],
    executeTemplateLatestCase: initialValues?.execute_template_latest_case ?? true,
    reduceSpeed: initialValues?.reduce_speed || 20,
    priority: initialValues?.priority || 3,
    interval: initialValues?.interval || 1,
    delay: initialValues?.delay || 130,
    report_email: initialValues?.report_email || false,
    reportFilter: initialValues?.reportFilter || false,
    send_filter: initialValues?.send_filter || 'ConditionAnyway',
    hideRecipientFields: false, // 控制是否隐藏收件主体相关字段
  })

  // 使用 useRef 来跟踪是否已经初始化
  const isInitialized = useRef(false)
  const taskTimeRef = useRef<moment.Moment | undefined>(formState.taskTime)
  const taskTimeMomentRef = useRef<moment.Moment | undefined>(formState.taskTime)
  const initialTaskTimeRef = useRef<moment.Moment | undefined>(formState.taskTime)
  const isTimeInitialized = useRef(false)
  const isTimeUpdating = useRef(false)

  // 初始化 taskTimeMomentRef
  useEffect(() => {
    if (initialValues?.task_time && !isTimeInitialized.current) {
      let momentTime: moment.Moment | undefined
      if (moment.isMoment(initialValues.task_time)) {
        momentTime = initialValues.task_time
      } else if (typeof initialValues.task_time === 'string') {
        momentTime = moment(initialValues.task_time, 'HH:mm:ss')
      }
      if (momentTime && momentTime.isValid()) {
        taskTimeMomentRef.current = momentTime
        taskTimeRef.current = momentTime
        initialTaskTimeRef.current = momentTime
        isTimeInitialized.current = true
        setFormState(prev => ({ ...prev, taskTime: momentTime }))
        console.log('Initialized time from initialValues:', momentTime.format('HH:mm:ss'))
      }
    }
  }, [initialValues?.task_time])

  // 更新 taskTimeRef 当 taskTime 变化时
  useEffect(() => {
    if (
      formState.taskTime &&
      (!taskTimeRef.current || !formState.taskTime.isSame(taskTimeRef.current)) &&
      !isTimeUpdating.current
    ) {
      if (formState.taskTime.isValid()) {
        taskTimeRef.current = formState.taskTime
        taskTimeMomentRef.current = formState.taskTime
        console.log('Updated time from formState:', formState.taskTime.format('HH:mm:ss'))
      }
    }
  }, [formState.taskTime])

  console.log('stateParams', stateParams)

  useEffect(() => {
    if (stateParams?.id && !isInitialized.current) {
      isInitialized.current = true
      getTaskBaseInfo(stateParams.id)
        .then(res => {
          console.log('res', res)
          const taskKind = res.data.taskKind
          let type
          if (taskKind === 'scheduler_type_immediate') {
            type = 1
          } else if (taskKind === 'scheduler_type_reserve') {
            type = 2
          } else if (
            taskKind === 'scheduler_type_daily' ||
            taskKind === 'scheduler_type_weekly' ||
            taskKind === 'scheduler_type_monthly'
          ) {
            type = 3
          } else if (
            taskKind === 'scheduler_type_hourly' ||
            taskKind === 'scheduler_type_minutely'
          ) {
            type = 4
          }

          // 处理时间格式
          let taskTimeMoment: moment.Moment | undefined
          if (type === 3 && res.data.cronSchedule?.timeOfDay) {
            const timeParts = res.data.cronSchedule.timeOfDay.split(' ')
            const timeString = timeParts[timeParts.length - 1] || ''
            if (timeString && timeString.match(/^\d{2}:\d{2}:\d{2}$/)) {
              taskTimeMoment = moment(timeString, 'HH:mm:ss')
            }
          } else if ((type === 2 || type === 4) && res.data.cycleTime) {
            taskTimeMoment = moment(res.data.cycleTime, 'HH:mm:ss')
          }

          console.log('Final taskTime:', taskTimeMoment)

          if (taskTimeMoment && taskTimeMoment.isValid()) {
            isTimeUpdating.current = true
            taskTimeMomentRef.current = taskTimeMoment
            taskTimeRef.current = taskTimeMoment
            initialTaskTimeRef.current = taskTimeMoment
            isTimeInitialized.current = true
            console.log('Valid moment time:', taskTimeMoment.format('HH:mm:ss'))
            isTimeUpdating.current = false
            setFormState(prev => ({
              ...prev,
              executeType: type,
              schedulerType: taskKind,
              taskTime: taskTimeMoment,
              executeTimesLimit: res.data.executeTimesLimit || 0,
              dayOfWeek: res.data.cronSchedule?.dayOfWeek || [],
              dayOfMonth: res.data.cronSchedule?.dayOfMonth || [],
              natMode: res.data.natMode || false,
              pcapCollection: res.data.pcapCollection || false,
            }))

            // 设置表单值
            const formValues = {
              name: res.data.name,
              business_site_id: res.data.siteId,
              group_id: res.data.groupId,
              execute_type: type,
              scheduler_type: taskKind,
              task_time: taskTimeMoment,
              execution_times: res.data.executeTimesLimit || 0,
              day_of_week: res.data.cronSchedule?.dayOfWeek || [],
              day_of_month: res.data.cronSchedule?.dayOfMonth || [],
              agent_id: res.data.agentIds || [],
              attack_agent_ids: res.data.attackAgentIds || [],
              target_email_id: res.data.targetEmailId || undefined,
              send_filter: res.data.send_filter || 'ConditionAnyway',
            }

            console.log('Setting form values with task_time:', taskTimeMoment?.format('HH:mm:ss'))

            // 确保所有值都设置后再调用 setFieldsValue
            createForm.setFieldsValue(formValues)

            // 检查编辑任务时的邮箱选择状态
            setTimeout(() => {
              const targetEmailId = formValues.target_email_id
              if (targetEmailId) {
                checkTargetEmailSelection(targetEmailId)
              }
            }, 0)
          }
        })
        .catch(_ => {})
    }
  }, [stateParams?.id])

  // 监听 initialValues 变化
  useEffect(() => {
    if (initialValues && !isInitialized.current) {
      console.log('initialValues-----------3333', initialValues)

      let taskTimeMoment: moment.Moment | undefined
      if (initialValues.task_time) {
        if (typeof initialValues.task_time === 'string') {
          taskTimeMoment = moment(initialValues.task_time, 'HH:mm:ss')
        } else if (moment.isMoment(initialValues.task_time)) {
          taskTimeMoment = initialValues.task_time
        }
      }

      // 如果已经有初始时间值，则使用它
      if (initialTaskTimeRef.current) {
        taskTimeMoment = initialTaskTimeRef.current
      }

      console.log('taskTime in initialValues', taskTimeMoment)

      // 更新 formState
      setFormState(prev => ({
        ...prev,
        ...initialValues,
        verifyMode: initialValues.verification_mode_id || prev.verifyMode,
        executeType: initialValues.execute_type || prev.executeType,
        executeTimes: initialValues.execute_times || prev.executeTimes,
        taskTime: taskTimeMoment || prev.taskTime,
        schedulerType: initialValues.scheduler_type || prev.schedulerType,
        executeTimesLimit: initialValues.execution_times || prev.executeTimesLimit,
        dayOfWeek: initialValues.day_of_week || prev.dayOfWeek,
        dayOfMonth: initialValues.day_of_month || prev.dayOfMonth,
        executeTemplateLatestCase:
          initialValues.execute_template_latest_case ?? prev.executeTemplateLatestCase,
        reduceSpeed: initialValues.reduce_speed || prev.reduceSpeed,
        priority: initialValues.priority || prev.priority || 3,
        send_filter: initialValues.send_filter || prev.send_filter,
        report_email: initialValues.report_email || prev.report_email,
        reportFilter: initialValues.reportFilter || prev.reportFilter,
      }))

      // 设置表单值
      const formValues = {
        ...initialValues,
        task_time: taskTimeMoment,
        execution_times: initialValues.execution_times || 0,
        day_of_week: initialValues.day_of_week || [],
        day_of_month: initialValues.day_of_month || [],
        agent_id: initialValues.agent_id || '',
        attack_agent_ids: initialValues.attack_agent_ids || [],
      }

      // 确保所有值都设置后再调用 setFieldsValue
      createForm.setFieldsValue(formValues)
    }
  }, [initialValues])

  // 初始化数据
  useEffect(() => {
    // 初始化月份列表
    const arr = Array.from({ length: 31 }, (_, i) => ({
      title: `${i + 1}${t('日')}`,
      value: i + 1,
    }))
    setMonthList(arr)

    console.log('initialValues', initialValues)
    console.log('formState22222222222222', formState)
    getEmailSendList().catch(_ => {})

    // 并行获取数据
    getTaskGroup({ page: 1, limit: 10000 })
      .then(res => {
        const initialFormValues = {
          group_id:
            initialValues?.group_id ||
            res.data.groups.find(item => item.groupName === t('常规任务'))?.groupId,
          execute_template_latest_case: formState.executeTemplateLatestCase,
          verification_mode_id: formState.verifyMode,
          name: initialValues?.name || '',
          execute_type: formState.executeType,
          execute_times: formState.executeTimes,
          priority: formState.priority || 3,
          interval: initialValues?.interval || 1,
          execute_unit: initialValues?.execute_unit || 'hour',
          execution_times: formState.executeTimesLimit,
          task_time: formState.taskTime,
          reduce_speed: formState.reduceSpeed,
          agent_id: initialValues?.agent_id || '',
          attack_agent_ids: initialValues?.attack_agent_ids || [],
          device_id: initialValues?.device_id || '',
          target_email_id: initialValues?.target_email_id || undefined,
          scheduler_type: formState.schedulerType,
          day_of_week: formState.dayOfWeek,
          day_of_month: formState.dayOfMonth,
          send_filter: formState.send_filter,
        }

        createForm.setFieldsValue(initialFormValues)

        // 检查初始邮箱选择状态
        setTimeout(() => {
          const initialTargetEmailId = initialFormValues.target_email_id
          if (initialTargetEmailId) {
            checkTargetEmailSelection(initialTargetEmailId)
          }
        }, 0)
      })
      .catch(_ => {})
  }, [])

  // 检查目标邮箱选择状态的辅助函数
  const checkTargetEmailSelection = (targetEmailId: any) => {
    console.log('targetEmailId', targetEmailId)
    if (targetEmailId && Array.isArray(targetEmailId) && targetEmailId.length === 3) {
      const selectedEmailId = targetEmailId[2]
      const selectedProtocol = targetEmailId[1]
      const selectedEmail = targetList
        .flatMap(area => area.emailsByProtocolInfos)
        .flatMap(protocol => protocol.emails)
        .find(email => email.id === selectedEmailId)

      if (selectedEmail) {
        // 隐藏收件主体和安全设备的条件：
        // 1. 邮箱类型为2（离线邮箱）
        // 2. 协议类型为'email_manual_collection'（手动收件）
        const shouldHideRecipientFields =
          selectedEmail.emailType === 'email_offline' ||
          String(selectedProtocol) === 'email_manual_collection'

        setFormState(prev => ({
          ...prev,
          hideRecipientFields: shouldHideRecipientFields,
        }))

        // 如果需要隐藏收件字段，清空相关表单值
        if (shouldHideRecipientFields) {
          createForm.setFieldsValue({
            agent_id: '',
            device_id: '',
          })
        }
      }
    } else {
      // 没有选择邮箱时，显示收件字段
      setFormState(prev => ({
        ...prev,
        hideRecipientFields: false,
      }))
      setAgentList([])
      setSecurityDeviceData([])
    }
  }

  // 监听攻击主体和目标主体变化，调用getSecurityDevice接口
  useEffect(() => {
    const targetEmailId =
      createForm.getFieldValue('target_email_id') && createForm.getFieldValue('target_email_id')[2]
        ? createForm.getFieldValue('target_email_id')[2]
        : ''
    if (targetEmailId && !formState.hideRecipientFields) {
      // 调用接口（暂时注释，使用mock数据）
      getSecurityDevice({ emailId: targetEmailId })
        .then(res => {
          setSecurityDeviceData(res?.data?.devicesOfType || [])
        })
        .catch(_ => {})
      getAgentList({ emailId: targetEmailId })
        .then(res => {
          setAgentList([
            {
              label:
                res.data.agentId === '0'
                  ? `${res.data.agentName}`
                  : `${res.data.agentName}(${res.data?.agentIps?.join(',')})`,
              value: res.data.agentId,
            },
          ])
          createForm.setFieldsValue({
            agent_id: res.data.agentId,
          })
        })
        .catch(_ => {})
    }
    if (!targetEmailId) {
      createForm.setFieldsValue({
        agent_id: '',
        device_id: '',
      })
    }
  }, [createForm.getFieldValue('target_email_id')])

  // 处理表单值变化
  const handleFormValueChange = (changedValues: any) => {
    if (changedValues.task_time) {
      const newTime = changedValues.task_time
      if (newTime && moment.isMoment(newTime) && newTime.isValid()) {
        isTimeUpdating.current = true
        taskTimeRef.current = newTime
        taskTimeMomentRef.current = newTime
        setFormState(prev => ({
          ...prev,
          ...changedValues,
          taskTime: newTime,
        }))
        isTimeUpdating.current = false
      } else {
        if (taskTimeMomentRef.current) {
          createForm.setFieldsValue({
            task_time: taskTimeMomentRef.current,
          })
        }
      }
    } else {
      const currentTime = taskTimeRef.current || formState.taskTime
      setFormState(prev => ({
        ...prev,
        ...changedValues,
        taskTime: currentTime,
      }))
      if (taskTimeMomentRef.current) {
        createForm.setFieldsValue({
          task_time: taskTimeMomentRef.current,
        })
      }
    }

    // 处理目标邮箱选择变化
    if (changedValues.target_email_id !== undefined) {
      checkTargetEmailSelection(changedValues.target_email_id)
    }
  }

  // 处理执行类型变化
  const handleExecuteTypeChange = (value: number) => {
    // 如果切换到高频任务，且之前不是高频任务，则清空用例选择
    if (value === 4 && formState.executeType !== 4) {
      onTemplateStateChange?.({
        selectedTemplateIds: templateState?.selectedTemplateIds || [],
        selectedCaseIds: [],
        templateSwitchStates: templateState?.templateSwitchStates || {},
      })
    }

    // 保存当前时间值
    const currentTime = taskTimeRef.current || formState.taskTime
    const currentMomentTime = taskTimeMomentRef.current

    isTimeUpdating.current = true
    setFormState(prev => ({
      ...prev,
      executeType: value,
      schedulerType: 'scheduler_type_daily',
      taskTime: currentTime,
      executeTimesLimit: 0,
      dayOfWeek: [],
      dayOfMonth: [],
      executeTemplateLatestCase: value === 3 ? true : false,
    }))

    createForm.setFieldsValue({
      execute_type: value,
      task_time: currentMomentTime,
      scheduler_type: 'scheduler_type_daily',
      execution_times: 0,
      day_of_week: [],
      day_of_month: [],
      execute_template_latest_case: value === 3 ? true : false,
    })
    isTimeUpdating.current = false
  }

  // 处理执行模板最新用例变化
  const handleExecuteTemplateLatestCaseChange = (checked: boolean) => {
    setFormState(prev => ({ ...prev, executeTemplateLatestCase: checked }))
    createForm.setFieldsValue({ execute_template_latest_case: checked })
  }

  // 星期参数
  const [weekList] = useState([
    { title: t('周一'), value: 1 },
    { title: t('周二'), value: 2 },
    { title: t('周三'), value: 3 },
    { title: t('周四'), value: 4 },
    { title: t('周五'), value: 5 },
    { title: t('周六'), value: 6 },
    { title: t('周日'), value: 0 },
  ])

  // 安全验证邮箱级联选择数据
  // 三层结构：安全域 -> 协议类型 -> 邮箱地址
  // 显示格式：生产安全域（12）-> POP3（3）-> prod.security@company.com
  const cascaderEmailVerificationData = useMemo(
    () =>
      targetList.map(area => {
        // 统计每个安全域的邮箱总数
        const totalEmails = area.emailsByProtocolInfos.reduce(
          (total, protocol) => total + protocol.emails.length,
          0,
        )

        return {
          value: area.areaId,
          label: (
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <span>{area.areaName}</span>
              {totalEmails > 0 && (
                <span style={{ color: '#4238C9', marginLeft: '8px' }}>({totalEmails})</span>
              )}
            </span>
          ),
          children: area.emailsByProtocolInfos.map(protocolInfo => ({
            value: protocolInfo.protocol,
            label: (
              <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <span>
                  {String(protocolInfo?.protocol)?.toUpperCase() === 'EMAIL_MANUAL_COLLECTION'
                    ? t('手动收件')
                    : String(protocolInfo?.protocol)?.toUpperCase() === 'EMAIL_POP3'
                    ? 'POP3'
                    : String(protocolInfo?.protocol)?.toUpperCase() === 'EMAIL_IMAP'
                    ? 'IMAP'
                    : String(protocolInfo?.protocol)?.toUpperCase() === 'EMAIL_OUTLOOK'
                    ? 'Outlook'
                    : ''}
                </span>
                {protocolInfo.emails.length > 0 && (
                  <span style={{ color: '#4238C9', marginLeft: '8px' }}>
                    ({protocolInfo.emails.length})
                  </span>
                )}
              </span>
            ),
            selectable: false, // 第二层不可选择
            children: protocolInfo.emails
              .sort((a, b) => {
                // 在线邮箱(emailType=email_online)排在前面，离线邮箱(emailType=email_offline)排在后面
                if (a.emailType === 'email_online' && b.emailType === 'email_offline') return -1
                if (a.emailType === 'email_offline' && b.emailType === 'email_online') return 1
                return 0
              })
              .map(email => ({
                value: email.id,
                label: (
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                      maxWidth: 250,
                    }}
                  >
                    <span>
                      <span>
                        <Typography.Text
                          ellipsis={{
                            tooltip: {
                              getPopupContainer: () => document.body,
                              placement: 'topLeft',
                              overlayStyle: { zIndex: 9999 },
                            },
                          }}
                          style={{ width: '200px' }}
                        >
                          {email.emailAddr}
                        </Typography.Text>
                      </span>
                      {email.emailType === 'email_offline' && (
                        <span style={{ color: '#999', fontSize: '12px', marginLeft: '8px' }} />
                      )}
                    </span>
                    <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                      {/* 设备配置状态图标提示 */}
                      {email.hasDevice && (
                        <Tooltip
                          title={
                            email.deviceStatus === 'device_status_online'
                              ? t('安全设备信息')
                              : t('安全设备不在线')
                          }
                          getPopupContainer={() => document.body}
                          placement="topRight"
                          arrowPointAtCenter
                        >
                          <SvgIcon
                            name={email.deviceStatus === 'device_status_online' ? '设备' : '设备灰'}
                            style={{ width: 16, height: 16, marginLeft: 10 }}
                          />
                        </Tooltip>
                      )}
                    </span>
                  </span>
                ),
                email: email,
              })),
          })),
        }
      }),
    [targetList],
  )

  // 自定义邮箱显示渲染函数（单选模式）
  const emailDisplayRender = (labels: string[], selectedOptions?: DefaultOptionType[]) => {
    if (!selectedOptions || selectedOptions.length === 0) return ''

    // 单选模式，获取最后一个选项（邮箱选项）
    const emailOption = selectedOptions[selectedOptions.length - 1]
    if (emailOption?.email) {
      return emailOption.email.emailAddr
    }

    return labels[labels.length - 1] || ''
  }

  // 递归提取所有 label 文本
  function extractLabelText(label: any): string {
    if (typeof label === 'string') return label
    if (React.isValidElement(label) && label.props) {
      const children = (label.props as { children?: any }).children
      if (typeof children === 'string') return children
      if (Array.isArray(children)) {
        return children.map(extractLabelText).join('')
      }
      if (children) return extractLabelText(children)
    }
    return ''
  }

  // Agent选择过滤
  const agentFilter = (inputValue: string, path: DefaultOptionType[]) => {
    const searchValue = inputValue.toLowerCase()
    return path.some(option => {
      const labelText = extractLabelText(option.label).toLowerCase()
      return labelText.includes(searchValue)
    })
  }

  // 安全设备过滤
  const deviceFilter = (inputValue: string, path: DefaultOptionType[]) => {
    const searchValue = inputValue.toLowerCase()
    return path.some(option => {
      const labelText = extractLabelText(option.label).toLowerCase()
      return labelText.includes(searchValue)
    })
  }

  // 邮箱验证过滤
  const emailFilter = (inputValue: string, path: DefaultOptionType[]) => {
    const searchValue = inputValue.toLowerCase()
    return path.some(option => {
      const labelText = extractLabelText(option.label).toLowerCase()
      return labelText.includes(searchValue)
    })
  }

  // 自定义Agent显示渲染函数
  const agentDisplayRender = (labels: string[], selectedOptions?: DefaultOptionType[]) => {
    if (!selectedOptions) return []

    return selectedOptions
      .map(option => {
        if (option?.agent) {
          // 获取父级选项的名称（安全域名称）
          const parentLabel = selectedOptions.find(opt =>
            opt.children?.some((child: any) => child.value === option.value),
          )?.value as string

          const agentName = option.agent.agentName
          return parentLabel ? `${parentLabel} ${agentName}` : agentName
        }
        return null
      })
      .filter(Boolean)
      .join('、')
  }

  // 站点选择 - 现在是两级结构：设备类型 -> 设备
  const cascaderDeviceListData = useMemo(
    () =>
      securityDeviceData.map(deviceType => {
        // 按状态分组设备
        const onlineDevices = deviceType.devices.filter(
          device => device.status === 'DeviceStatusOnline',
        )
        const offlineDevices = deviceType.devices.filter(
          device => device.status !== 'DeviceStatusOnline',
        )

        return {
          value: deviceType.deviceType,
          label: (
            <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <span>{deviceType.deviceType}</span>
              {deviceType.devices.length > 0 && (
                <span style={{ color: '#4238C9', marginLeft: '8px' }}>
                  ({deviceType.devices.length})
                </span>
              )}
            </span>
          ),
          selectable: false, // 第一层不可选择
          children: [...onlineDevices, ...offlineDevices].map(device => ({
            value: device.id,
            disabled: device.status !== 'DeviceStatusOnline',
            label: (
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <span>
                  {device.name}|{device.ip}
                </span>
                <Badge
                  style={{ marginLeft: 10 }}
                  status={device.status === 'DeviceStatusOnline' ? 'success' : 'default'}
                />
              </span>
            ),
            device: {
              id: device.id,
              name: device.name,
              ip: device.ip,
              status: device.status,
            },
          })),
        }
      }),
    [securityDeviceData],
  )

  // 自定义显示渲染函数
  const displayRender = (labels: string[], selectedOptions?: DefaultOptionType[]) => {
    if (!selectedOptions || selectedOptions.length === 0) return ''

    // 单选模式，获取最后一个选项（设备选项）
    const deviceOption = selectedOptions[selectedOptions.length - 1]
    if (deviceOption?.device) {
      return `${deviceOption.device.name}|${deviceOption.device.ip}`
    }

    return labels[labels.length - 1] || ''
  }

  const siteSearchRender = (inputValue: string, path: DefaultOptionType[]) => {
    if (path.length === 0) return null
    const searchValue = inputValue.toLowerCase()
    return (
      <span>
        {path.map((option, idx) => {
          const labelText = extractLabelText(option.label)
          const lowerLabel = labelText.toLowerCase()
          const matchIdx = lowerLabel.indexOf(searchValue)
          if (matchIdx !== -1 && searchValue) {
            // 高亮匹配部分
            return (
              <span key={idx}>
                {labelText.slice(0, matchIdx)}
                <span style={{ color: '#4238c9', fontWeight: 600 }}>
                  {labelText.slice(matchIdx, matchIdx + searchValue.length)}
                </span>
                {labelText.slice(matchIdx + searchValue.length)}
                {idx < path.length - 1 ? ' / ' : ''}
              </span>
            )
          }
          return (
            <span key={idx}>
              {labelText}
              {idx < path.length - 1 ? ' / ' : ''}
            </span>
          )
        })}
      </span>
    )
  }

  return (
    <Container>
      <Form
        id="waf-create-config-form"
        onFinish={submitForm}
        form={createForm}
        layout="horizontal"
        colon={false}
        labelWrap
        labelCol={{ flex: '75px' }}
        onValuesChange={handleFormValueChange}
        initialValues={{
          verification_mode_id: formState.verifyMode,
          verify_mode: formState.verifyMode,
          execute_type: formState.executeType,
          execute_times: formState.executeTimes,
          priority: formState.priority || 3,
          execute_template_latest_case: formState.executeTemplateLatestCase,
          reduce_speed: formState.reduceSpeed,
          task_time: formState.taskTime,
          agent_id: '',
          attack_agent_ids: [],
          target_email_id: undefined,
          device_id: '',
          reportFilter: false,
          send_filter: '',
          report_email: false,
          delay: 130,
          interval: 1,
        }}
      >
        {/* 任务基本信息 */}
        <div className="section">
          <div className="section-title">
            {t('任务基本信息')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <Form.Item
              label={t('任务名称')}
              name="name"
              required
              rules={[
                { required: true, message: t('请输入任务名称') },
                { max: 50, message: t('任务名称最多50字') },
                {
                  pattern: /^(?=.*\S).+$/,
                  message: t('任务名称不能全部为空格'),
                },
              ]}
              className="form-item required"
            >
              <Input placeholder={t('请输入')} style={{ width: '300px' }} allowClear />
            </Form.Item>

            <Form.Item label={t('任务分组')} name="group_id" className="form-item">
              <Select placeholder={t('请选择')} style={{ width: 300 }} allowClear>
                {taskGroup?.map(item => (
                  <Select.Option key={item.groupId} value={item.groupId}>
                    {item.groupName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>

        {/* 任务验证配置 */}
        <div className="section">
          <div className="section-title">
            {t('任务验证配置')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <Form.Item
              label={t('验证模式')}
              name="verification_mode_id"
              className="form-item"
              rules={[{ required: true, message: t('请选择验证模式') }]}
              style={{ marginLeft: 35 }}
            >
              <Checkbox.Group
                disabled
                onChange={e => {
                  setFormState(prev => ({ ...prev, verifyMode: e as number[] }))
                  createForm.setFieldsValue({
                    verification_mode_id: e as number[],
                    agent_id: '',
                    device_id: '',
                  })
                }}
                value={[2]}
                style={{ marginLeft: 10 }}
              >
                <Space>
                  <Checkbox value={2}>
                    {t('平台')}
                    <span style={{ color: '#A6A3D6' }}> → </span>
                    {t('邮箱')}
                  </Checkbox>
                </Space>
              </Checkbox.Group>
            </Form.Item>

            {formState.verifyMode.includes(2) && (
              <div className="verify-config">
                <div className="config-title-box">
                  <div className="config-title">
                    <span style={{ color: '#86909C', marginRight: 8 }}>{t('模式配置')}</span>
                    <span style={{ color: '#86909C' }}>{t('平台')}</span>
                    <span style={{ color: '#A6A3D6' }}> → </span>
                    <span style={{ color: '#86909C' }}>{t('邮箱')}</span>
                  </div>
                </div>
                <div className="config-form">
                  <Form.Item
                    label={<span style={{ color: '#333', fontWeight: 400 }}>{t('攻击主体')}</span>}
                    required
                    className="attack-subject-form-item"
                  >
                    <div className="flex-row">
                      <div className="label">{t('平台发件地址')}</div>
                      <Form.Item
                        noStyle
                        name={'email_server_id'}
                        rules={[{ required: true, message: t('请选平台发件地址') }]}
                      >
                        <Select
                          placeholder={t('请选择发件地址')}
                          key={emailList[0]?.id}
                          optionLabelProp={'label'}
                        >
                          {emailList?.map(item => (
                            <Select.Option value={item.id} key={item.id} label={item.name}>
                              {item?.name} （{item?.origin_type === 1 ? t('内置') : t('自定义')}）
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Button
                        type="link"
                        onClick={() => {
                          window.open('/system/email-server', '_blank')
                        }}
                      >
                        {t('添加')}
                      </Button>
                    </div>
                  </Form.Item>

                  <Form.Item
                    label={<span style={{ color: '#333', fontWeight: 400 }}>{t('目标主体')}</span>}
                    className="target-subject-form-item"
                    required
                  >
                    <div className="flex-row">
                      <div className="label">{t('安全验证邮箱')}</div>
                      <Form.Item
                        noStyle
                        name="target_email_id"
                        rules={[{ required: true, message: t('请选安全验证邮箱') }]}
                      >
                        <Cascader
                          placeholder={t('请选择安全域/协议/邮箱')}
                          options={cascaderEmailVerificationData}
                          showArrow
                          displayRender={emailDisplayRender}
                          showSearch={{
                            filter: emailFilter,
                            matchInputWidth: true,
                            render: siteSearchRender,
                            limit: 50,
                          }}
                          dropdownMenuColumnStyle={{ maxWidth: 520 }}
                          onChange={value => {
                            createForm.setFieldsValue({ target_email_id: value })
                            // 调用辅助函数处理邮箱选择逻辑
                            checkTargetEmailSelection(value)
                          }}
                        />
                      </Form.Item>
                      <Button
                        type="link"
                        onClick={() => {
                          window.open('/configure/site/mailbox', '_blank')
                        }}
                      >
                        {t('添加邮箱')}
                      </Button>
                    </div>
                  </Form.Item>

                  {!formState.hideRecipientFields && (
                    <Form.Item
                      label={
                        <span style={{ color: '#333', fontWeight: 400, marginLeft: 10 }}>
                          {t('收件主体')}
                        </span>
                      }
                      className="target-subject-form-item"
                    >
                      <div className="flex-row">
                        <div className="label">{t('收件Agent')}</div>
                        <Form.Item noStyle name="agent_id">
                          <Select
                            disabled={createForm.getFieldValue('target_email_id')}
                            placeholder={t('请选择收件Agent')}
                            options={agentList}
                            style={{ width: 300 }}
                          />
                        </Form.Item>
                        <Button
                          type="link"
                          onClick={() => {
                            window.open('/configure/client/list', '_blank')
                          }}
                        >
                          {t('添加')}
                        </Button>
                      </div>
                    </Form.Item>
                  )}

                  {!formState.hideRecipientFields && (
                    <Form.Item
                      label={
                        <span style={{ color: '#333', fontWeight: 400 }}>{t('安全设备')}</span>
                      }
                      className="security-device-form-item"
                    >
                      <div className="flex-row">
                        <Form.Item noStyle name="device_id">
                          <Cascader
                            placeholder={t('安全设备')}
                            options={cascaderDeviceListData}
                            showArrow
                            displayRender={displayRender}
                            showSearch={{
                              filter: deviceFilter,
                              matchInputWidth: true,
                              render: (inputValue, path) => {
                                if (path.length === 0) return inputValue
                                const searchValue = inputValue.toLowerCase()
                                return (
                                  <span>
                                    {path.map((option, idx) => {
                                      const labelText = extractLabelText(option.label)
                                      const lowerLabel = labelText.toLowerCase()
                                      const matchIdx = lowerLabel.indexOf(searchValue)
                                      if (matchIdx !== -1 && searchValue) {
                                        return (
                                          <span key={idx}>
                                            {labelText.slice(0, matchIdx)}
                                            <span style={{ color: '#4238c9', fontWeight: 600 }}>
                                              {labelText.slice(
                                                matchIdx,
                                                matchIdx + searchValue.length,
                                              )}
                                            </span>
                                            {labelText.slice(matchIdx + searchValue.length)}
                                            {idx < path.length - 1 ? ' / ' : ''}
                                          </span>
                                        )
                                      }
                                      return (
                                        <span key={idx}>
                                          {labelText}
                                          {idx < path.length - 1 ? ' / ' : ''}
                                        </span>
                                      )
                                    })}
                                  </span>
                                )
                              },
                              limit: 50,
                            }}
                            dropdownMenuColumnStyle={{ maxWidth: 520 }}
                            onChange={value => {
                              // 现在是两级结构，不需要链路选择逻辑
                              // value 是选中设备的值数组
                            }}
                          />
                        </Form.Item>
                        <Button
                          type="link"
                          onClick={() => {
                            window.open('/configure/device/access-management', '_blank')
                          }}
                        >
                          {t('添加接入设备')}
                        </Button>
                      </div>
                      {/* 移除链路选择提示，现在是两级结构 */}
                    </Form.Item>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 任务执行配置 */}
        <div className="section">
          <div className="section-title">
            {t('任务执行配置')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <Form.Item
              label={t('执行类型')}
              name="execute_type"
              required
              className="form-item radio-box"
            >
              <Radio.Group
                onChange={e => {
                  handleExecuteTypeChange(e.target.value)
                }}
                value={formState.executeType}
              >
                <Radio.Button value={1}>{t('即时任务')}</Radio.Button>
                <Radio.Button value={2}>{t('定时任务')}</Radio.Button>
                <Radio.Button value={3}>{t('周期任务')}</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <div>
              {formState.executeType === 2 && (
                <div className="execute-config">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 24,
                      marginLeft: 115,
                    }}
                  >
                    <Form.Item
                      name="task_time"
                      label={
                        <span style={{ fontWeight: 400, color: '#666' }}>{t('执行开始时间')}</span>
                      }
                      rules={[{ required: true, message: t('请选择执行开始时间') }]}
                    >
                      <DatePicker
                        placeholder={t('请选择日期与时间')}
                        style={{
                          width: '236px',
                          fontSize: '14px',
                          borderRadius: '6px',
                        }}
                        showTime
                        value={formState.taskTime}
                        onChange={value => {
                          setFormState(prev => ({ ...prev, taskTime: value }))
                        }}
                        disabledDate={disabledDate}
                        disabledTime={disabledDateTime}
                      />
                    </Form.Item>
                  </div>
                </div>
              )}
            </div>
            <div>
              {formState.executeType === 3 && (
                <div className="execute-config">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 24,
                      marginLeft: 125,
                    }}
                  >
                    <span
                      style={{ marginRight: 12, fontWeight: 400, color: '#666', marginLeft: 10 }}
                    >
                      {t('周期配置')}
                    </span>
                    <div>
                      <Input.Group compact style={{ display: 'flex' }}>
                        <Form.Item name="scheduler_type" noStyle>
                          <Select
                            style={{ width: '98px' }}
                            value={formState.schedulerType}
                            onChange={e => {
                              // 保存当前时间值
                              const currentTime = taskTimeRef.current || formState.taskTime
                              const currentMomentTime = taskTimeMomentRef.current

                              isTimeUpdating.current = true
                              setFormState(prev => ({
                                ...prev,
                                schedulerType: e,
                                taskTime: currentTime,
                              }))

                              // 确保时间值不被清空
                              if (currentMomentTime) {
                                createForm.setFieldsValue({
                                  task_time: currentMomentTime,
                                })
                              }
                              isTimeUpdating.current = false
                            }}
                          >
                            <Select.Option value="scheduler_type_daily">{t('每日')}</Select.Option>
                            <Select.Option value="scheduler_type_weekly">{t('每周')}</Select.Option>
                            <Select.Option value="scheduler_type_monthly">
                              {t('每月')}
                            </Select.Option>
                          </Select>
                        </Form.Item>
                        {formState.schedulerType === 'scheduler_type_daily' && (
                          <div
                            style={{
                              display: 'flex',
                              borderRadius: '0 6px 6px 0',
                              marginRight: 10,
                              alignItems: 'center',
                            }}
                          >
                            <Form.Item
                              name="task_time"
                              noStyle
                              rules={[{ required: true, message: t('请选择执行开始时间') }]}
                            >
                              <TimePicker
                                style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                value={formState.taskTime}
                                format="HH:mm:ss"
                                onChange={value => {
                                  if (value && value.isValid()) {
                                    isTimeUpdating.current = true
                                    taskTimeMomentRef.current = value
                                    taskTimeRef.current = value
                                    setFormState(prev => ({ ...prev, taskTime: value }))
                                    createForm.setFieldsValue({ task_time: value })
                                    isTimeUpdating.current = false
                                  } else {
                                    if (taskTimeMomentRef.current) {
                                      createForm.setFieldsValue({
                                        task_time: taskTimeMomentRef.current,
                                      })
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </div>
                        )}
                        {formState.schedulerType === 'scheduler_type_weekly' && (
                          <Input.Group compact>
                            <div className="date-select">
                              <Form.Item
                                name="day_of_week"
                                noStyle
                                rules={[{ required: true, message: t('请选择星期') }]}
                              >
                                <TreeSelect
                                  showSearch={false}
                                  treeData={weekList}
                                  treeCheckable
                                  maxTagCount={1}
                                  showCheckedStrategy="SHOW_PARENT"
                                  style={{
                                    width: '120px',
                                    borderRadius: 'none',
                                    textAlign: 'left',
                                  }}
                                  placeholder={t('请选择星期')}
                                  value={formState.dayOfWeek}
                                  onChange={(week: string[]) => {
                                    setFormState(prev => ({
                                      ...prev,
                                      dayOfWeek: week,
                                      taskTime: taskTimeRef.current,
                                    }))
                                  }}
                                />
                              </Form.Item>
                            </div>
                            <Form.Item
                              name="task_time"
                              noStyle
                              rules={[{ required: true, message: t('请选择执行开始时间') }]}
                            >
                              <TimePicker
                                style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                value={formState.taskTime}
                                format="HH:mm:ss"
                                onChange={value => {
                                  if (value && value.isValid()) {
                                    isTimeUpdating.current = true
                                    taskTimeMomentRef.current = value
                                    taskTimeRef.current = value
                                    setFormState(prev => ({ ...prev, taskTime: value }))
                                    createForm.setFieldsValue({ task_time: value })
                                    isTimeUpdating.current = false
                                  } else {
                                    if (taskTimeMomentRef.current) {
                                      createForm.setFieldsValue({
                                        task_time: taskTimeMomentRef.current,
                                      })
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </Input.Group>
                        )}
                        {formState.schedulerType === 'scheduler_type_monthly' && (
                          <Input.Group compact>
                            <div className="date-select" style={{ borderRadius: 'none' }}>
                              <Form.Item
                                name="day_of_month"
                                noStyle
                                rules={[{ required: true, message: t('请选择日期') }]}
                              >
                                <TreeSelect
                                  treeData={monthList}
                                  treeCheckable
                                  key="value"
                                  showCheckedStrategy="SHOW_PARENT"
                                  style={{ width: '120px' }}
                                  maxTagCount={1}
                                  value={formState.dayOfMonth}
                                  onChange={(e: any) => {
                                    setFormState(prev => ({
                                      ...prev,
                                      dayOfMonth: e,
                                      taskTime: taskTimeRef.current,
                                    }))
                                  }}
                                  placeholder={t('选择日期')}
                                />
                              </Form.Item>
                            </div>
                            <Form.Item
                              name="task_time"
                              noStyle
                              rules={[{ required: true, message: t('请选择执行开始时间') }]}
                            >
                              <TimePicker
                                style={{ width: '200px', borderRadius: '0 6px 6px 0' }}
                                value={formState.taskTime}
                                format="HH:mm:ss"
                                onChange={value => {
                                  if (value && value.isValid()) {
                                    isTimeUpdating.current = true
                                    taskTimeMomentRef.current = value
                                    taskTimeRef.current = value
                                    setFormState(prev => ({ ...prev, taskTime: value }))
                                    createForm.setFieldsValue({ task_time: value })
                                    isTimeUpdating.current = false
                                  } else {
                                    if (taskTimeMomentRef.current) {
                                      createForm.setFieldsValue({
                                        task_time: taskTimeMomentRef.current,
                                      })
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </Input.Group>
                        )}
                        <div style={{ width: 230 }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ width: 50, fontWeight: 400, color: '#666' }}>
                              {t('总执行')}
                            </div>
                            <Form.Item name="execution_times" noStyle>
                              <InputNumber
                                style={{ margin: '0 4px', width: '150px' }}
                                placeholder={t('默认不限次数')}
                                min={0}
                                max={999}
                                value={formState.executeTimesLimit}
                                onChange={val => {
                                  setFormState(prev => ({
                                    ...prev,
                                    executeTimesLimit: val || undefined,
                                  }))
                                }}
                              />
                            </Form.Item>
                            <span>{t('次')}</span>
                          </div>
                        </div>
                      </Input.Group>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="execute-config">
              <Form.Item label={t('发送间隔')} name="interval" className="form-item">
                <InputNumber
                  placeholder={t('请选择')}
                  style={{ width: 300, marginRight: 16 }}
                  min={1}
                  max={999}
                  value={formState.interval}
                  onChange={value => {
                    setFormState(prev => ({ ...prev, interval: value }))
                    createForm.setFieldsValue({ interval: value })
                  }}
                  addonAfter={<span>{t('秒')}</span>}
                />
                <Tooltip title={t('可配区间1-999')}>
                  <SvgIcon name="提示" style={{ width: '14px', height: '14px', marginTop: 6 }} />
                </Tooltip>
              </Form.Item>
              <Form.Item
                label={
                  <div className="custom-label">
                    <span>{t('投递延迟')}</span>
                  </div>
                }
                name="delay"
                className="form-item"
              >
                <InputNumber
                  placeholder={t('请选择')}
                  style={{ width: 300, marginRight: 16 }}
                  value={formState.delay}
                  min={1}
                  max={600}
                  onChange={value => {
                    setFormState(prev => ({ ...prev, delay: value }))
                    createForm.setFieldsValue({ delay: value })
                  }}
                  addonAfter={<span>{t('分钟')}</span>}
                />
                <Tooltip
                  title={t(
                    '配置后任务将按配置时间在任务投递完成后进行结果接收，接收时间完成任务将立即结束，可配区间：1-600分钟',
                  )}
                >
                  <SvgIcon name="提示" style={{ width: '14px', height: '14px', marginTop: 6 }} />
                </Tooltip>
              </Form.Item>
              <Form.Item
                label={
                  <div className="custom-label">
                    <span>{t('优先级')}</span>
                  </div>
                }
                name="priority"
                className="form-item"
              >
                <Select
                  placeholder={t('请选择')}
                  style={{ width: 300, marginRight: 16 }}
                  value={formState.priority}
                  onChange={value => {
                    setFormState(prev => ({ ...prev, priority: value }))
                    createForm.setFieldsValue({ priority: value })
                  }}
                >
                  <Select.Option value={1}>1</Select.Option>
                  <Select.Option value={2}>2</Select.Option>
                  <Select.Option value={3}>3</Select.Option>
                  <Select.Option value={4}>4</Select.Option>
                  <Select.Option value={5}>5</Select.Option>
                </Select>
                <Tooltip title={t('数字越大，优先级越高')}>
                  <SvgIcon name="提示" style={{ width: '14px', height: '14px', marginTop: 2 }} />
                </Tooltip>
              </Form.Item>
              {formState.executeType === 3 && (
                <Form.Item
                  label={t('执行增量')}
                  name="execute_template_latest_case"
                  className="execute-template-latest-case form-item"
                >
                  <Form.Item name="execute_template_latest_case" noStyle>
                    <BasSwitch
                      checked={formState.executeTemplateLatestCase}
                      onChange={handleExecuteTemplateLatestCaseChange}
                    />
                  </Form.Item>
                  <Tooltip
                    title={t('启用后则对全选用例的模版周期执行时执行新添加到模版中的用例')}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <SvgIcon
                      name="提示"
                      style={{ width: '14px', height: '14px', marginTop: 2, marginLeft: 10 }}
                    />
                  </Tooltip>
                </Form.Item>
              )}
            </div>
          </div>
        </div>

        {/* 报表发送配置 */}
        <div className="section">
          <div className="section-title">
            {t('报表发送配置')}
            <div className="section-bar" />
          </div>
          <div className="form-content">
            <div className="code" style={{ display: 'flex' }}>
              <Form.Item
                label={
                  <div className="custom-label">
                    <span>{t('发送报表')}</span>
                  </div>
                }
                valuePropName="checked"
                name="report_email"
                className="form-item"
              >
                <BasSwitch
                  onChange={value => setFormState(prev => ({ ...prev, report_email: value }))}
                  checked={formState.report_email}
                />
              </Form.Item>
              {formState.report_email && (
                <Form.Item
                  label={<span style={{ color: '#666' }}>{t('发送邮箱')}</span>}
                  name="emailList"
                  className="encoding-type-form-item"
                  rules={[{ required: true, message: t('请选择发送邮箱') }]}
                >
                  <Select
                    placeholder={t('请选择发送邮箱')}
                    mode="multiple"
                    showArrow
                    allowClear
                    maxTagCount={1}
                    style={{ width: 300 }}
                  >
                    {emailSendList.map(item => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}/{item.email}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </div>
            {formState.report_email && (
              <div className="code" style={{ display: 'flex' }}>
                <Form.Item
                  label={
                    <div className="custom-label">
                      <span>{t('过滤配置')}</span>
                    </div>
                  }
                  valuePropName="checked"
                  name="reportFilter"
                  className="form-item"
                >
                  <BasSwitch
                    onChange={value => setFormState(prev => ({ ...prev, reportFilter: value }))}
                    checked={formState.reportFilter}
                  />
                </Form.Item>
                {formState.reportFilter && (
                  <Form.Item
                    label={<span style={{ color: '#666' }}>{t('过滤条件')}</span>}
                    name="send_filter"
                    className="encoding-type-form-item"
                    rules={[{ required: true, message: t('请选择过滤条件') }]}
                  >
                    <Radio.Group>
                      <Radio value={'ConditionAnyway'}>{t('任意用例防护失效')}</Radio>
                      <Radio value={'ConditonAllFailed'}>{t('全部用例防护失效')}</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
              </div>
            )}
          </div>
        </div>
      </Form>
    </Container>
  )
}

const Container = styled.div`
  background: #fff;
  border-radius: 8px;
  .section {
    margin-bottom: 24px;
    padding: 0 16px;
    .section-title {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      position: relative;
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 88px;
        height: 6px;
        background: linear-gradient(90deg, #2090a8 0%, #4238c9 100%);
        border-radius: 0px 86px 0px 100px;
        margin-top: 8px;
      }
      .section-bar {
        content: '';
        display: block;
        width: 100%;
        height: 4px;
        background: #ebeaf9;
        margin-top: 10px;
      }
    }

    .form-content {
      margin-top: 16px;
      .custom-label {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .form-item {
        margin-left: 35px;
      }
      .execute-config {
        border-radius: 8px;
        .flex-row {
          margin-left: 115px;
        }
        .execute-template-latest-case label {
          width: 70px;
          line-height: 20px;
          height: 40px;
        }
        .execute-template-latest-case {
          .ant-form-item-label {
            flex: 0 0 70px;
            white-space: normal;
            text-align: right;
            margin-right: 10px;
          }
          .ant-row {
            align-items: center;
          }
          .ant-form-item-control-input-content {
            display: flex;
            align-items: center;
            .ant-switch {
              margin-right: 5px;
            }
          }
        }
      }
      .verify-config {
        .config-title-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .nat-switch-box {
            label {
              color: #86909c;
            }
          }
        }
        .flex-row {
          display: flex;
          align-items: center;
          gap: 0;
          width: 100%;

          .label {
            width: 100px;
            color: #666;
            margin-left: 30px;
            white-space: nowrap;
            flex-shrink: 0;
          }

          .ant-form-item {
            flex: 1;
            margin-bottom: 0;
          }

          .ant-btn-link {
            margin-left: auto;
            flex-shrink: 0;
          }
        }
        .attack-subject-form-item,
        .snat-form-item,
        .attack-node-form-item {
          .ant-form-item-explain-error {
            margin-left: 125px;
          }
          .ant-form-item-label {
            white-space: nowrap;
            min-width: 100px;
            flex: 0 0 100px;
          }
        }
        .attack-subject-form-item {
          .ant-select-in-form-item {
            width: 300px;
          }
        }
        .security-device-form-item {
          label {
            margin-right: 12px;
          }
          .ant-select-in-form-item {
            width: 410px;
          }
          .ant-form-item-explain-error {
            margin-left: 135px;
          }
          .ant-cascader-menus .ant-cascader-menu:first-child .ant-cascader-checkbox {
            display: none !important;
          }
          .ant-cascader-menus .ant-cascader-menu:nth-child(2) .ant-cascader-checkbox {
            display: none !important;
          }
          .ant-form-item-label {
            white-space: nowrap;
            min-width: 120px;
            flex: 0 0 120px;
          }
        }
        .target-subject-form-item {
          .ant-select-in-form-item {
            width: 300px;
          }
          .ant-cascader {
            width: 300px;
          }
          .ant-form-item-explain-error {
            margin-left: 125px;
          }
          .ant-form-item-label {
            white-space: nowrap;
            min-width: 100px;
            flex: 0 0 100px;
          }
        }
      }
      .radio-box {
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
          border-color: #d9d9d9;
          color: #4238c9;
          background: #e9e8f9;
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
          background: #d9d9d9;
        }
        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
          box-shadow: none;
        }
      }
      .encoding-type-form-item {
        margin-left: 24px;
      }
    }

    .ant-form-item-label {
      font-weight: 500;
      white-space: nowrap;
      text-align: right;
    }
  }
`

const FormItem = styled(Form.Item)`
  margin-bottom: 24px;
`
